<template>
    <BaseComponent
        clase="teatros-home-section"
    >
        <div class="col-md-6 col-sm-12" :class="!footer.renovar_abono ? 'disabled' : ''" v-if="!footer.ocultar_renovar_abono"> 
            <router-link
                v-if="footer.renovar_abono"
                :to="{ name: 'front.abonos.renovar.index' }"
            >
                
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>
                    {{ $t('home.renovar', {abono : teatro.texto_abono}) }}
                </span>
                
            </router-link>

            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ $t('home.renovar', {abono : teatro.texto_abono}) }}</del></span>
            </a>
        </div>
        <div class="col-md-6 col-sm-12" :class="!footer.nuevo_abono ? 'disabled' : ''" v-if="!footer.ocultar_abonos">
            <router-link 
                v-if="footer.nuevo_abono"
                :to="{ name: 'front.abonos.nuevo.index' }"
            >
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>
                    {{ abonado.btn_nuevo_abono ? abonado.btn_nuevo_abono : (teatro.hash !== '8IuCwC47T9n0qgn2ky0G' ? $t('home.nuevo_abono', {abono: teatro.texto_abono}) : $t('home.nuevo_abono_talavera', {abono: teatro.texto_abono.toUpperCase()})) }}
                </span>
            </router-link>

            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ abonado.btn_nuevo_abono ? abonado.btn_nuevo_abono : (teatro.hash !== '8IuCwC47T9n0qgn2ky0G' ? $t('home.nuevo_abono', {abono: teatro.texto_abono}) : $t('home.nuevo_abono_talavera', {abono: teatro.texto_abono.toUpperCase()})) }}</del></span>
            </a>
        </div>
        <div class="col-md-6 col-sm-12" :class="!footer.partidos ? 'disabled' : ''" v-if="!footer.ocultar_eventos">
            <router-link
                v-if="footer.partidos"
                :to="{ name: 'front.eventos.index' }"
            >
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>{{ $t('home.eventos') }}</span>
            </router-link>
            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ $t('home.eventos') }}</del></span>
            </a>
        </div>
        <div class="col-md-6 col-sm-12" :class="!footer.activar_productos ? 'disabled' : ''" v-if="!footer.ocultar_productos">
            <router-link
                v-if="footer.activar_productos"
                :to="{ name: 'front.productos.index' }"
            >
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>{{ $t('productos.productos') }}</span>
            </router-link>
            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ $t('productos.productos') }}</del></span>
            </a>
        </div>
        <div class="col-md-6 col-sm-12" v-if="!footer.ocultar_acreditaciones">
            <router-link
                v-if="footer.activar_acreditaciones"
                :to="{ name: 'front.acreditacion' }"
            >
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>{{ $t('home.acreditacion') }}</span>
            </router-link>
            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ $t('home.acreditacion') }}</del></span>
            </a>
        </div>
    </BaseComponent>
</template>

<script>
    import BaseComponent from '@/components/frontend/home/BaseComponent';

    export default {
        components: {
            BaseComponent
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            logo() {
                if(this.footer.logo_teatros) {
                    return this.footer.logo_teatros;
                }
                return this.footer.logo;
            },
            abonado(){
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro
            }
        }
    }
</script>


